export default function ExportLink(props) {
    const params = new URLSearchParams(props).toString();
    return <a className="export-link" target="order" href={`https://circlejourney.net/commform?${params}`}>Order this style &gt;</a>;
}